import feathers from "@feathersjs/client";
import rest from "@feathersjs/rest-client";
import auth from "@feathersjs/authentication-client";
import axios from "axios";

const api = feathers();
console.log("API JS **** ", process.env.REACT_APP_API_URL);
const restClient = rest(process.env.REACT_APP_API_URL);

api.configure(restClient.axios(axios));
api.configure(feathers.authentication());
api.configure(
  auth({
    storage: window.localStorage,
    //storageKey: "accessToken",
  })
);

export { api };
